import React, { useRef, useState } from "react";
import { Form, Overlay, Tooltip } from "react-bootstrap";
import InputDetail from "./InputDetail";
import infobtn from "../../assets/images/infobtnblue.svg";
import { ENUMS } from "../../services/Enums";
const Decimal = ({ compObj, handleChange, isDisable, showtype, labelAction, nodeContext }) => {
    const [showInputDetailPopup, setShowInputDetailPopu] = useState(false);
    const targetInputDetail = useRef();

    const handleOverlay = (e) => {
        let element = document.getElementById(e?.currentTarget?.id);
        if (element) {
            if (element.classList.contains("overlay-isopen")) {
                element.classList.remove("overlay-isopen");
            } else {
                element.classList.add("overlay-isopen");
            }
        }
    };

    const handleShowInputDetailPopup = (e) => {
        if (document.getElementById("body").classList.contains("popup-is-open")) {
            document.getElementById("body").classList.remove("popup-is-open");
            handleOverlay(e);
        } else {
            document.getElementById("body").classList.add("popup-is-open");
        }
        setShowInputDetailPopu(!showInputDetailPopup);
    };
    return (
        <>
            <div className="config-input-label-container">
                <Form.Label className="common-label text-capitalize">
                    {compObj?.parakey.replaceAll("_", " ")}
                    {showtype && <> ({compObj?.paratype})</>}
                </Form.Label>
                {compObj?.details && (
                    <span
                        className="config-info-btn cursor-pointer"
                        onClick={(e) => {
                            e.preventDefault();
                            handleOverlay(e);
                            setShowInputDetailPopu(!showInputDetailPopup);
                            handleShowInputDetailPopup();
                        }}
                        ref={targetInputDetail}
                    >
                        <img src={infobtn} alt="infobtn" />
                    </span>
                )}
                {
                    !ENUMS.workflowparamsnotbindonthiskey.includes(compObj?.parakey.toUpperCase()) &&
                    labelAction
                }
            </div>

            <Form.Control
                type="text"
                pattern="^\d*\.?\d*$"
                className="common-input"
                value={compObj?.value ? compObj?.value : ""}
                onChange={(e) => {
                    if (handleChange) {
                        if (e.target.validity.valid) {
                            handleChange(e, compObj);
                        }
                        if (e.target.value === "") {
                            handleChange(e, compObj);
                        }
                    }
                }}
                disabled={isDisable ? isDisable : false}
                list="suggestions"
            />
            {showInputDetailPopup && (
                <Overlay
                    target={targetInputDetail.current}
                    show={handleShowInputDetailPopup}
                    placement="bottom"
                    flip
                >
                    <Tooltip id="overlay-example">
                        <InputDetail
                            handleshowPopup={handleShowInputDetailPopup}
                            compObj={compObj}
                        />
                    </Tooltip>
                </Overlay>
            )}
        </>
    );
};

export default Decimal;
